import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../component-library/icon';

const AiButtonArrow = ({
	action,
	isDisabled = false,
	label = '',
	title = '',
}) => (
	<button
		type="button"
		className="ignite-ai__button-arrow"
		title={title}
		onClick={() => action()}
		disabled={isDisabled}
	>
		{label ? (
			<div className="ignite-ai__button-arrow-label-container">
				<div className="ignite-ai__button-arrow-label">{label}</div>
				<div><Icon icon="arrow-up" /></div>
			</div>
		) : (
			<Icon icon="arrow-up" />
		)}
	</button>
);

export default AiButtonArrow;

AiButtonArrow.propTypes = {
	action: PropTypes.func.isRequired,
	isDisabled: PropTypes.bool,
	label: PropTypes.string,
	title: PropTypes.string,
};
